import { useMemo } from 'react'
import { Dropdown } from 'components/common'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { buildEnumOptions, FilterMeta } from 'utils/helpers'

type Props = {
  filterMeta?: FilterMeta
}

export const FILTER_FIELD_TALABAT_LOG = 'talabatLogFilters'

const TalabatLogFilterForm = ({ filterMeta }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_TALABAT_LOG)

  const operationTypeOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'operationType', [
        'ADD_ITEM',
        'UPDATE_ITEM',
        'UPDATE_ITEM_DELTA',
        'MANAGE_PROMOTION',
      ]),
    [filterMeta],
  )

  const statusOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'status', [
        'PENDING',
        'SENT',
        'COMPLETED',
        'FAILED',
        'ERROR',
      ]),
    [filterMeta],
  )

  const extStatusOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'extStatus', [
        'QUEUED',
        'IN_PROGRESS',
        'COMPLETED',
        'FAILED',
        'DUPLICATE',
      ]),
    [filterMeta],
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="min-w-[200px]">
        <Dropdown
          name="operationType"
          label="Operation Type"
          options={operationTypeOptions}
          defaultValue={filters.operationType || ''}
          setValue={(_field: string, value: string) =>
            setField('operationType', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <Dropdown
          name="status"
          label="Status"
          options={statusOptions}
          defaultValue={filters.status || ''}
          setValue={(_field: string, value: string) =>
            setField('status', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <Dropdown
          name="extStatus"
          label="External Status"
          options={extStatusOptions}
          defaultValue={filters.extStatus || ''}
          setValue={(_field: string, value: string) =>
            setField('extStatus', value)
          }
        />
      </div>

      <FilterTextInput
        label="Job ID"
        value={filters.jobId || ''}
        onApply={(value) => setField('jobId', value)}
      />

      <FilterTextInput
        label="Store ID"
        value={filters.storeId || ''}
        onApply={(value) => setField('storeId', value)}
      />

      <FilterTextInput
        label="Vendor ID"
        value={filters.vendorId || ''}
        onApply={(value) => setField('vendorId', value)}
      />

      <FilterTextInput
        label="Chain ID"
        value={filters.chainId || ''}
        onApply={(value) => setField('chainId', value)}
      />

      <FilterTextInput
        label="Aggregator ID"
        value={filters.aggregatorId || ''}
        onApply={(value) => setField('aggregatorId', value)}
      />

      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />

      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default TalabatLogFilterForm
